export default __webpack_public_path__ + "static/kb_3_17-e95b9c8f23c56b680feb4a65adc86e61.jpg";